module.exports = __webpack_public_path__ + "img/sc_m.98cfbe1d.jpg";